import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiEndpoints } from '../../constants/api-endpoints.config';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private apiEndPoint: any = ApiEndpoints;
  url: string = environment.apiurls.baseUrl;

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  /**
   * This function is used to create profile.
   * @param body 
   * @returns 
   */
  createProfile(body: any): Observable<any> {
    return this.http.post(`${this.url}${this.apiEndPoint.profile.createProfile}`, body);
  }

  /**
   * This function is used to update profile.
   * @param body 
   * @returns 
   */
  updateProfile(body: any, userId: any) {
    return this.apiService.put(`${this.url}${this.apiEndPoint.profile.updateProfile}${userId}`, body);
  }

  /**
   * This function is used to get all profile
   */
  getProfiles(): Observable<any> {
    return this.apiService.get(`${this.url}${this.apiEndPoint.profile.getProfiles}`);
  }

  /**
   * This function is used to get profile by id.
   * @param userId 
   * @returns 
   */
  getProfileById(userId: any): Observable<any> {
    return this.apiService.get(`${this.url}${this.apiEndPoint.profile.updateProfile}${userId}`);
  }

  /**
   * This function is used to upload profile image.
   * @param formData 
   * @returns 
   */
  uploadProfile(formData: any): Observable<any> {
    return this.http.post(`${this.url}${this.apiEndPoint.uploadFile.upload}`, formData);
  }

  /**
   * This function is used to update password.
   * @param payLoad 
   * @returns 
   */
  updatePasswordByUserId(userId: any, body: any): Observable<any> {
    return this.apiService.put(`${this.url}${this.apiEndPoint.auth.updatePassword}${userId}`, body)
  }
}
